module.exports = __webpack_public_path__ + "static/img/5.89b9c48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/5.png
// module id = oGRZ
// module chunks = 0